<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  methods: {
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  },
  mounted: function () {
    //从code进来
    if (this._isMobile()) {
      window.onload = function () {
        getRem(375, 100);
      };
      window.onresize = function () {
        getRem(375, 100);
      };
      function getRem (pwidth, prem) {
        var html = document.getElementsByTagName("html")[0];
        var oWidth =
          document.body.clientWidth || document.documentElement.clientWidth;
        html.style.fontSize = (oWidth / pwidth) * prem + "px";
      }
      let flagGo = localStorage.getItem("code");
      if (flagGo == 0) {
        this.$router.replace("/mobile");
      } else {
      }
    }
    // else {
    //   // pc端首页路由
    //   this.$router.replace("/query");
    // }
  }
};
</script>

<style>
html {
  font-size: 5px;
}

@media screen and(min-width: 200px) and(max-width: 450px) {
  html {
    font-size: 4px;
  }
}

@media screen and(min-width: 451px) and(max-width: 649px) {
  html {
    font-size: 6px;
  }
}

@media screen and(min-width: 650px) and(max-width: 850px) {
  html {
    font-size: 8px;
  }
}

@media screen and (max-width: 1024px) and (min-width: 851px) {
  html {
    font-size: 9.5px;
  }
}

@media screen and (max-width: 1399px) and (min-width: 1025px) {
  html {
    font-size: 11px;
  }
}

@media screen and (max-width: 2000px) and (min-width: 1400px) {
  html {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue